import { render, staticRenderFns } from "./solveConsultation.vue?vue&type=template&id=6a2ff74e&scoped=true&"
import script from "./solveConsultation.vue?vue&type=script&lang=js&"
export * from "./solveConsultation.vue?vue&type=script&lang=js&"
import style0 from "./solveConsultation.vue?vue&type=style&index=0&id=6a2ff74e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ff74e",
  null
  
)

export default component.exports